import React from "react";
import { RefEpaycoStyled } from './style';
import config from "../../config/enviroment";
var PowerByEpayco = function () {
    return (React.createElement(RefEpaycoStyled, null,
        React.createElement("img", { className: "icon", src: config.urlS3 + "/wom/icons/union.png", alt: "security" }),
        React.createElement("p", { className: "paymentProcessEpayco" }, "Pagos procesados por"),
        React.createElement("img", { src: config.urlS3 + "/wom/epayco.png", alt: "logo E payco" })));
};
export default PowerByEpayco;
